import { render } from "./face-detection-view.vue?vue&type=template&id=6da2a773&scoped=true"
import script from "./face-detection-view.vue?vue&type=script&lang=js"
export * from "./face-detection-view.vue?vue&type=script&lang=js"

import "./face-detection-view.vue?vue&type=style&index=0&id=6da2a773&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da2a773"]])

export default __exports__